import { AppBar, Box, Button, Dialog, DialogContent, IconButton, Slide, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import React from "react";
import MonthlySales from "./PerformanceReview/Revenues"; 
import Operations from "./PerformanceReview/Operations";
import Pricing from "./PerformanceReview/Pricing";
import Trends from "./PerformanceReview/Trends";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PerformanceReview({ mode, height, title }: { mode: string, height: number, title: string }){
    const [value, setValue] = React.useState('1');
    const [open, setOpen] = React.useState(false);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ display: 'flex', backgroundColor: 'white', flexDirection: 'column', width: '100%', height: '100%', maxHeight: '100% !important', borderRadius: '6px !important', border: '1px solid #f0f0f0 !important'}}>  
            <Box sx={{ width: '100%', height: 'auto', flex :'row', padding: '2px 0 2px 0', justifyContent: 'flex-start', alignItems: 'center' }}>
                {title && <Typography variant="h6" sx={{ margin: 0, padding: 2, fontSize: 'clamp(0.9rem, 3vw, 1.1rem) !important;' }}>
                    {title}
                    {user.assignments > 0 && <Button variant="text" startIcon={<FullscreenIcon fontSize="small" />} color="primary" style={{ textTransform: 'capitalize', float: 'right' }} onClick={handleOpen}>Maximize</Button>}
                </Typography>}
            </Box>
            <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, padding: 0, borderRadius: '6px !important', backgroundColor: 'white' }}>
                {user.assignments > 0 ? (
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: 0, padding: 0 }}>
                            <Tabs 
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                selectionFollowsFocus
                                onChange={handleChange} 
                                aria-label="performance review tabs" 
                                value={value}
                            >
                                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Revenues" value="1" />
                                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Operations" value="2" />
                                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Pricing" value="3" />
                                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Trends" value="4" />
                            </Tabs>
                        </Box>
                        <TabPanel value="1">
                            <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-15px 0 0 0', padding: 0 }}>
                                <MonthlySales height={height} />
                            </Box>
                        </TabPanel>
                        <TabPanel value="2">
                            <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-15px 0 0 0', padding: 0 }}>
                                <Operations height={height} />
                            </Box>
                        </TabPanel>
                        <TabPanel value="3">
                            <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-15px 0 0 0', padding: 0 }}>
                                <Pricing height={height} />
                            </Box>
                        </TabPanel>
                        <TabPanel value="4">
                            <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-15px 0 0 0', padding: 0 }}>
                                <Trends height={height} />
                            </Box>
                        </TabPanel>
                    </TabContext>
                    ) : (
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', typography: 'body1', height: 'auto', margin: '-15px 0 0 0', padding: 0 }}>
                            <Typography variant="body1" sx={{ fontFamily: 'Trebuchet MS', margin: '10px 2px', color: 'text.secondary' }}>
                                It seems you are not assigned to any customers.
                            </Typography>
                        </Box>
                    )}
                </Box>
                <Dialog fullScreen open={open} TransitionComponent={Transition} onClose={handleClose}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Performance Review</Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <PerformanceReview mode={mode} height={window.innerHeight - 300} title='' />
                        </Box>
                    </DialogContent>
                </Dialog>
        </Box>
    )
}